/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Trade request
 */
export interface TradeRequest {
  /**
   * Account ID.
   */
  accountId: number;
  /**
   * Trade direction.
   */
  side: TradeRequest.SideEnum;
  /**
   * Qty for client(in base asset).
   */
  units: number;
  /**
   * Pair IDs for execution. Only LP pairs with same basePairId allowed.
   */
  pairIds: Array<number>;
  /**
   * Total for client(in quote asset).
   */
  total: number;
  /**
   * Rate for client.
   */
  clientRate: number;
}
export namespace TradeRequest {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
